import { lazy, memo, Suspense } from "react";
import { Button } from "react-bootstrap";
import CountUp from "react-countup";

const ExpertsVideos = lazy(() => import("./ExpertsVideos"));

const PROFILE_IMG_SIZE = 80;
const BENEFITS = [
  {
    title: "Muslim International Markets",
    description:
      "Expert advice and support to enter new global markets, including tailored go-to-market (G2M) strategies and business partnerships.",
  },
  {
    title: "Exclusive Trade Missions",
    description:
      "Enjoy early access and discounted rates on SMBF's international delegations, connecting with key global business leaders to form powerful partnerships.",
  },
  {
    title: "Personalised Consultancy",
    description:
      "Access bespoke consultancy services tailored to your business's unique challenges and growth goals, ensuring you are set for success on a global scale.",
  },
  {
    title: "Recruitment Support",
    description:
      "Get assistance in finding the right talent for your business needs.",
  },
  {
    title: "Access to the SMBF Network",
    description:
      "Tap into a powerful network of high-level executives, decision-makers, and industry influencers worldwide.",
  },
  {
    title: "Facilitated Introductions",
    description:
      "Gain direct introductions to other SMBF members, international partners, and exclusive contacts to help drive your global growth strategy.",
  },
  {
    title: "Business Resources",
    description:
      "Access valuable industry reports, strategic business templates, and tools to support executive decision-making and growth initiatives.",
  },
  {
    title: "Free Networking Events",
    description:
      "Enjoy complimentary tickets to SMBF's exclusive networking events, where you can connect with senior executives, industry leaders, and top-tier professionals.",
  },
];

const LANDING_CLIP_STYLE: React.CSSProperties = {
  clipPath: "ellipse(180% 75% at 50% 25%)",
};
const CARD_CLIP_STYLE: React.CSSProperties = {
  clipPath: "ellipse(180% 75% at 50% 75%)",
};
const ICON_BOX_STYLE: React.CSSProperties = { minWidth: 40, height: 40 };

const SUSPENSE_FALLBACK_STYLE: React.CSSProperties = { minHeight: 320 };

function ExecutiveMembership() {
  return (
    <div className="w-100">
      <div
        style={LANDING_CLIP_STYLE}
        className="p-2 p-md-5 member-benefits-landing d-flex flex-column gap-3 justify-items-center justify-content-center text-white text-center"
      >
        <h5 className="d-inline-block blur-bg p-2 px-4 rounded-pill fs-5 fw-semibold text-White mx-auto">
          Executive Membership
        </h5>
        <h1 className="px-md-5 px-1 display-5 fw-bold">
          Unlock Global Markets and Strategic Growth with Executive-Level
          Support
        </h1>
        <p className=" px-md-5 px-1 fs-4 fw-semibold text-light">
          Join SMBF's Executive Membership and gain access to high-level
          business partnerships, international market expansion, and exclusive
          consultancy. Take your business global with a network built for
          leaders.
        </p>
        <div>
          <Button className="px-5">VIEW BENEFITS</Button>
        </div>
        <div className="d-flex align-items-center justify-content-center gap-4 gap-md-5 text-white px-4 py-3">
          <div className="image-stack position-relative d-flex">
            <img
              src="/SMBF-23.jpeg"
              alt="SMBF executive members"
              className="profile-img z-2"
              width={PROFILE_IMG_SIZE}
              height={PROFILE_IMG_SIZE}
              loading="eager"
              decoding="async"
            />
            <img
              src="/SMBF-24.jpeg"
              alt="SMBF network"
              className="profile-img z-1 position-absolute second-img"
              width={PROFILE_IMG_SIZE}
              height={PROFILE_IMG_SIZE}
              loading="lazy"
              decoding="async"
            />
            <img
              src="/SMBF-25.jpeg"
              alt="SMBF community"
              className="profile-img z-2 position-absolute third-img"
              width={PROFILE_IMG_SIZE}
              height={PROFILE_IMG_SIZE}
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="ms-5 px-5">
            <h3 className="mb-0 fw-bold text-white">
              <CountUp end={5000} duration={1} separator="," suffix="+" />
            </h3>
            <h5 className="mb-0 text-light">Network</h5>
          </div>
        </div>
      </div>
      <div className="container py-4 d-flex gap-4 flex-column align-items-center justify-content-center">
        <h2>What You Get as an SMBF Executive Member</h2>
        {BENEFITS.map((item) => (
          <div
            key={item.title}
            className="benefit-container w-100 bg-primary bg-opacity-25 text-dark rounded-4 p-4 d-flex align-items-start gap-3"
          >
            <div
              className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
              style={ICON_BOX_STYLE}
            >
              <i className="bi bi-check-lg fs-5"></i>
            </div>
            <div>
              <h4 className="fw-bold mb-1">{item.title}</h4>
              <p className="fs-5">{item.description}</p>
            </div>
          </div>
        ))}
        <h2>All for £90/month</h2>
        <Button className="px-5">REGISTER NOW</Button>
      </div>
      <div
        style={CARD_CLIP_STYLE}
        className="card-bg px-3 py-4 px-md-10 py-md-5"
      >
        <div className="d-flex justify-content-center flex-column align-items-center mt-4 mt-md-5">
          <h2 className="fs-24 fs-md-40">
            See How SMBF is Supporting Businesses Like Yours
          </h2>
          <Suspense fallback={<div style={SUSPENSE_FALLBACK_STYLE} aria-hidden="true" />}>
            <ExpertsVideos />
          </Suspense>
          <h2 className="fs-24 fs-md-40 text-center px-5 mb-5">
            Ready to Lead Your Business into Global Markets for £90/month?
          </h2>
          <Button className="px-5">REGISTER NOW</Button>
        </div>
      </div>
    </div>
  );
}

ExecutiveMembership.displayName = "ExecutiveMembership";

export default memo(ExecutiveMembership);
